import useNavigation from "@/utils/useNavigate";
import React, { useEffect, useRef, useState } from "react";
import styles from "./BrandPreview.module.less";
interface BrandPreviewProps {
  title?: string;
  brandInfoList?: {
    brandId: string;
    brandName: string;
    logoUrl: string;
  }[];
  control?: any;
}

const BrandPreview: React.FC<BrandPreviewProps> = prop => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const barRef = useRef<HTMLDivElement>(null);
  const thumbRef = useRef<HTMLDivElement>(null);
  const [thumbPosition, setThumbPosition] = useState(0);
  const [maxMove, setMaxMove] = useState(0);
  const [needScroll, setNeedScroll] = useState(false);
  const { control } = prop;
  const { track } = control;

  const { navigate2Activity, navigate2BrandDetail } = useNavigation();

  const calculateMaxMove = () => {
    if (barRef.current && thumbRef.current) {
      // 使用getBoundingClientRect获取精确的宽度，包括小数部分
      const barRect = barRef.current.getBoundingClientRect();
      const thumbRect = thumbRef.current.getBoundingClientRect();
      setMaxMove(barRect.width - thumbRect.width);
    }
  };

  useEffect(() => {
    // 初始计算
    calculateMaxMove();

    // 监听窗口大小变化
    window.addEventListener("resize", calculateMaxMove);

    return () => window.removeEventListener("resize", calculateMaxMove);
  }, []);

  useEffect(() => {
    const scrollElement = scrollRef.current;
    if (!scrollElement) {
      return;
    }

    const handleScroll = () => {
      const { scrollLeft, scrollWidth, clientWidth } = scrollElement;
      setThumbPosition((maxMove * scrollLeft) / (scrollWidth - clientWidth || 1));
    };

    scrollElement.addEventListener("scroll", handleScroll);
    return () => scrollElement.removeEventListener("scroll", handleScroll);
  }, [maxMove]);

  useEffect(() => {
    // 判断是否需要滚动
    const scrollElement = scrollRef.current;
    if (!scrollElement) {
      return;
    }
    const { scrollWidth, clientWidth } = scrollElement;
    setNeedScroll(scrollWidth > clientWidth);
  }, [prop.brandInfoList]);

  useEffect(() => {
    calculateMaxMove();
  }, [needScroll]);

  const onBrandClick = (item: any) => {
    if (track.track) {
      track.track("resource_click", {
        page_name: control.pageName,
        content_id: control.planId || "",
        previous_page_name: control.search.get("page_name") || "",
        resource_type: "品牌模块",
        resource_name: item.brandName,
        brand_id: item.brandId,
      });
    }

    if (item?.activityIds && item?.activityIds.length > 0) {
      return navigate2Activity({
        activityNo: item?.activityIds[0],
      });
    }
    return navigate2BrandDetail(item?.brandId);
  };

  const titleClass = () => {
    const t = prop.title || "";
    if (t.length <= 10) {
      return styles.titleLg;
    }
    if (t.length > 13) {
      return styles.titleSm;
    }
    return styles.titleDf;
  };
  return (
    <div className={styles.BrandPreview}>
      <div className={styles.BrandPreviewTitle}>
        <span className={titleClass()}>{prop.title}</span>
        <img
          className={styles.BrandPreviewIcon}
          src="https://akim-oss.aikucun.com/ca6afbd30d12ce2e702d0d53eeb053e6c8bcfae1_1750127109411_45.png"
        />
      </div>
      <div className={styles.BrandPreviewBox}>
        <img
          className={styles.BrandPreviewImg}
          src="https://akim-oss.aikucun.com/f04f40d9271aa847c825a0da605db028c481f946_1750127109404_6.png"
        />
        <div
          className={`${styles.brandWrapper} ${prop?.brandInfoList && prop?.brandInfoList?.length <= 5 ? styles.displayWrapper : ""}`}
          ref={scrollRef}>
          {prop?.brandInfoList?.map((item, index) => (
            <div className={styles.brandItem} key={index} onClick={() => onBrandClick(item)}>
              <div className={styles.logo}>
                <img src={item.logoUrl} />
              </div>
              <div className={styles.name}>{item.brandName}</div>
            </div>
          ))}
        </div>
        {needScroll && (
          <div className={styles.brandBar} ref={barRef}>
            <div
              className={styles.brandThumb}
              ref={thumbRef}
              style={{ left: `${thumbPosition}px` }}></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default BrandPreview;
